import SlidingOverlayPanel from '../common/SlidingOverlayPanel';
import useAgentsHome from './useAgentsHome';
import AgentsHomeWithDialogs from './AgentsHomeWithDialogs';
import { PanelEnvSelector } from '../pages/environments/connect-env/PanelEnvSelector';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import { AgentChatInstanceProvider } from './AgentChatInstanceContext';
import { ChatInstance } from './ChatInstance';

interface AgentsHomePanelProps {
  closePanel?: () => void;
}

const AgentsHomePanel = ({ closePanel }: AgentsHomePanelProps) => {
  const { isExpanded, isOpened } = useAgentsHome();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);

  return (
    <SlidingOverlayPanel isOpened={isOpened} isExpanded={isExpanded}>
      <PanelEnvSelector filterByEnvsUsedInCanvas />
      <AgentChatInstanceProvider instanceId={ChatInstance.agentsPanel}>
        <AgentsHomeWithDialogs isPageView={false} closePanel={closePanel} key={crmOrgId} />
      </AgentChatInstanceProvider>
    </SlidingOverlayPanel>
  );
};

export default AgentsHomePanel;
